import * as React from 'react'
import styled from 'styled-components/macro'
import Button from 'common/Button'
import FAQItem from './FAQItem'
import {QUERIES} from './constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px;
  @media ${QUERIES.tabletAndUp} {
    padding: 128px;
  }
  padding-bottom: 40px;
  background: linear-gradient(var(--dark-grey), var(--darker-grey));
`

const Title = styled.div`
  font-family: 'Rubik';
  font-weight: 700;
  font-style: italic;
  font-size: calc(24 / 16 * 1rem);
  text-align: center;
  padding-top: 64px;
  @media ${QUERIES.tabletAndUp} {
    padding-top: 0;
    font-size: calc(40 / 16 * 1rem);
    line-height: calc(47 / 16 * 1rem);
    text-align: initial;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
`

const FAQ = ({setShowQuoteModal, FAQQuestions}) => {
  const [answersOpen, setAnswersOpen] = React.useState([])
  const showAnswer = answerID => {
    const newAnswersOpen = [...answersOpen]
    const foundIndex = newAnswersOpen.findIndex(ans => ans === answerID)
    if (foundIndex < 0) {
      newAnswersOpen.push(answerID)
      setAnswersOpen(newAnswersOpen)
    }
  }
  const hideAnswer = answerID => {
    const newAnswersOpen = [...answersOpen]
    const foundIndex = newAnswersOpen.findIndex(ans => ans === answerID)
    if (foundIndex > -1) {
      newAnswersOpen.pop(answerID)
      setAnswersOpen(newAnswersOpen)
    }
  }
  return (
    <Container>
      <Title>Frequently Asked Questions</Title>
      {FAQQuestions.map((faq, index) => (
        <FAQItem
          faq={faq}
          key={index}
          index={index}
          answersOpen={answersOpen}
          hideAnswer={hideAnswer}
          showAnswer={showAnswer}
        />
      ))}
      {setShowQuoteModal && (
        <Button onClick={setShowQuoteModal}>Reserve Now</Button>
      )}
    </Container>
  )
}
export default FAQ
